const slider = document.querySelector(".root4-testimonials-slider");
const carousel = document.querySelector(".root4-testimonials-carousel");

const prev = document.querySelector(".root4-testimonials-arrowleft");
const next = document.querySelector(".root4-testimonials-arrowright");

const dotsContainer = document.querySelector(".root4-testimonials-dots");
const sections = document.querySelectorAll(
  ".root4-testimonials-slider section"
);

let currentIndex = 0;
var direction = -1;
let isAnimating = false;
let pauseAutoSlide = false;
let AutoSlideTimer;

let blockSize = parseInt(slider.getAttribute("data-block-size"), 10);
const translateValue = 100 / blockSize;

//dragging vars
// New variables for drag/swipe functionality
let isDragging = false;
let startX = 0;
let currentDeltaX = 0;
let dragThreshold = 50; // minimum pixels to trigger a slide

setInterval(() => {
  if (pauseAutoSlide) return;
  if (isAnimating) return;
  isAnimating = true;
  if (direction === 1) {
    slider.prepend(slider.lastElementChild);
    direction = -1;
  }
  currentIndex = (currentIndex + 1) % sections.length;
  carousel.style.justifyContent = "flex-start";
  slider.style.transform = `translateX(-${translateValue}%)`;
  updateDots();
}, 5000);

// Initialize dots
function initDots() {
  sections.forEach((_, index) => {
    const dot = document.createElement("div");
    dot.classList.add("root4-testimonials-dot");
    dot.classList.toggle("active", index === currentIndex);
    dotsContainer.appendChild(dot);
  });
}

// Update active dot
function updateDots() {
  const dots = document.querySelectorAll(".root4-testimonials-dot");
  dots.forEach((dot, i) => dot.classList.toggle("active", i === currentIndex));
}

// Initialize dots and add event listeners
initDots();
dotsContainer.addEventListener("click", handleDotClick);

next.addEventListener("click", function () {
  slideNext();
});

prev.addEventListener("click", function () {
  slidePrev();
});

slider.addEventListener("transitionend", function () {
  if (direction === -1) {
    slider.appendChild(slider.firstElementChild);
  } else if (direction === 1) {
    slider.prepend(slider.lastElementChild);
  }

  slider.style.transition = "none";
  slider.style.transform = "translate(0)";

  setTimeout(function () {
    slider.style.transition = "all 0.6s";
    isAnimating = false;
  });
});

// Handle dot clicks
function handleDotClick(e) {
  if (e.target.classList.contains("root4-testimonials-dot")) {
    // const index = parseInt(e.target.dataset.index);
    // currentIndex = index;
    // updateDots(currentIndex);
    // Add logic here to move the carousel to the corresponding section
  }
}

// start of the dragging code

// Helper function to slide to next
function slideNext() {
  if (isAnimating) return;
  isAnimating = true;
  if (direction === 1) {
    slider.prepend(slider.lastElementChild);
    direction = -1;
  }
  currentIndex = (currentIndex + 1) % sections.length;
  carousel.style.justifyContent = "flex-start";
  slider.style.transform = `translateX(-${translateValue}%)`;
  updateDots();

  pauseAutoSlide = true;
  clearTimeout(AutoSlideTimer);
  AutoSlideTimer = setTimeout(() => {
    pauseAutoSlide = false;
  }, 8000);
}

// Helper function to slide to previous
function slidePrev() {
  if (isAnimating) return;
  isAnimating = true;
  if (direction === -1) {
    slider.appendChild(slider.firstElementChild);
    direction = 1;
  }
  currentIndex = (currentIndex - 1 + sections.length) % sections.length;
  carousel.style.justifyContent = "flex-end";
  slider.style.transform = `translateX(${translateValue}%)`;
  updateDots();

  pauseAutoSlide = true;
  clearTimeout(AutoSlideTimer);
  AutoSlideTimer = setTimeout(() => {
    pauseAutoSlide = false;
  }, 8000);
}

// For mouse events:
slider.addEventListener("mousedown", dragStart);
slider.addEventListener("mousemove", dragMove);
slider.addEventListener("mouseup", dragEnd);
slider.addEventListener("mouseleave", dragEnd);

// For touch events:
slider.addEventListener("touchstart", dragStart, { passive: true });
slider.addEventListener("touchmove", dragMove, { passive: false }); // preventDefault may be used
slider.addEventListener("touchend", dragEnd);

function getEventX(e) {
  // For both mouse and touch events
  return e.type.includes("touch") ? e.touches[0].clientX : e.clientX;
}

function dragStart(e) {
  // If an animation is in progress, do not initiate a drag
  if (isAnimating) return;

  pauseAutoSlide = true;
  isDragging = true;
  startX = getEventX(e);
  slider.style.transition = "none";
}

function dragMove(e) {
  if (!isDragging || isAnimating) return; // optionally check isAnimating here
  if (e.type === "touchmove") e.preventDefault();
  let currentX = getEventX(e);
  currentDeltaX = currentX - startX;

  let sliderWidthPx = slider.offsetWidth;
  let deltaPercent = (currentDeltaX / sliderWidthPx) * 100;

  slider.style.transform = `translateX(${deltaPercent}%)`;
}

function dragEnd(e) {
  if (!isDragging || isAnimating) return; // optionally check isAnimating here
  isDragging = false;
  slider.style.transition = "all 0.6s";

  if (Math.abs(currentDeltaX) > dragThreshold) {
    if (currentDeltaX < 0) {
      slideNext();
    } else {
      slidePrev();
    }
  } else {
    slider.style.transform = "translateX(0)";
  }

  currentDeltaX = 0;
  clearTimeout(AutoSlideTimer);
  AutoSlideTimer = setTimeout(() => {
    pauseAutoSlide = false;
  }, 8000);
}
